import * as ApiHealthChecks from './health-checks'

export const Api = {
  healthCheck: ApiHealthChecks,
}
